import React from "react";
import { atom, useRecoilState } from "recoil";
import styled from "styled-components";
import {
  PointTabBar,
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../Benefit/Point/PointTab";

export const validCheckTabState = atom<number>({
  key: "validCheckTabState",
  default: 0,
});

export default function ValidCheckTab() {
  const [tab, setTab] = useRecoilState(validCheckTabState);

  return (
    <PointTabContainer>
      <PointTabColumn onClick={() => setTab(0)}>
        <PointTabText isActive={Boolean(tab === 0)}>
          유효성 체크 관리
        </PointTabText>

        <PopupTabBar tab={tab} />
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(1)}>
        <PointTabText isActive={Boolean(tab === 1)}>신고된 파티</PointTabText>
      </PointTabColumn>
    </PointTabContainer>
  );
}

const PopupTabBar = styled(PointTabBar)`
  width: ${({ tab }) => (tab === 0 ? 119 : 85)}px;
  left: ${({ tab }) => (tab === 0 ? 0 : 137)}px;
`;
